import {
    CREATE_ADS,
    CREATE_ADS_FAILURE,
    CREATE_ADS_SUCCESS,
    DELETE_ADS,
    DELETE_ADS_FAILURE,
    DELETE_ADS_SUCCESS,
    EDIT_ADS,
    EDIT_ADS_FAILURE,
    EDIT_ADS_SUCCESS,
    GET_ADS_LISTING,
    GET_ADS_LISTING_FAILURE,
    GET_ADS_LISTING_SUCCESS,
} from "../constants";

const initialState = {
    isLoading: false,
    editAdsLoader: false,
    createAdsLoader: false,
    locations: [],
    ads: [],
    count: 0,
    deleted: 0,
    ad: {},
    error: null,
};

export default function AdsReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ADS_LISTING:
        case GET_ADS_LISTING_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                count: action.payload.total,
                ads: action.payload.records,
                deleted: action.payload.deleted,
            };
            break;
        case GET_ADS_LISTING_FAILURE:

        case DELETE_ADS:
        case DELETE_ADS_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                error: null,
            };
            break;
        case DELETE_ADS_FAILURE:
            state = {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            break;

        case EDIT_ADS:
            state = {
                ...state,
                error: null,
                editAdsLoader: true,
            };
            break;

        case EDIT_ADS_SUCCESS:
            state = {
                ...state,
                editAdsLoader: false,
                error: null,
            };
            break;

        case EDIT_ADS_FAILURE:
            state = {
                ...state,
                editAdsLoader: false,
                error: action.payload,
            };
            break;

        case CREATE_ADS:
            state = {
                ...state,
                error: null,
                createAdsLoader: true,
            };
            break;

        case CREATE_ADS_SUCCESS:
            state = {
                ...state,
                createAdsLoader: false,
                error: null,
            };
            break;

        case CREATE_ADS_FAILURE:
            state = {
                ...state,
                createAdsLoader: false,
                error: action.payload,
            };
            break;

        default:
            break;
    }

    return state;
}
